const t = new class {
  constructor() {
    this.raf = t => {
      requestAnimationFrame(this.raf);
      const a = t - this.now;
      this.now = t;
      for (let s = 0; s < this.callbacks.length; s++) this.callbacks[s].callback(t, a);
    }, "undefined" != typeof window && (this.callbacks = [], this.now = performance.now(), requestAnimationFrame(this.raf));
  }
  add(t) {
    let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return this.callbacks.push({
      callback: t,
      priority: a
    }), this.callbacks.sort((t, a) => t.priority - a.priority), () => this.remove(t);
  }
  remove(t) {
    this.callbacks = this.callbacks.filter(_ref => {
      let {
        callback: a
      } = _ref;
      return t !== a;
    });
  }
}();
export { t as raf };